import React from "react";

function RescheduleIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 32 32"
    >
      <g fill="#fff" data-name="Layer 13">
        <path
          d="M28 4h-2V3a1 1 0 00-2 0v1h-4V3a1 1 0 00-2 0v1h-4V3a1 1 0 00-2 0v1H8V3a1 1 0 00-2 0v1H4a2 2 0 00-2 2v22a2 2 0 002 2h24a2 2 0 002-2V6a2 2 0 00-2-2zM6 6a1 1 0 002 0h4a1 1 0 002 0h4a1 1 0 002 0h4a1 1 0 002 0h2v4H4V6zM4 28V12h24v16z"
          data-original="#000000"
        ></path>
        <path
          d="M21.27 17.13A6 6 0 0010 19.61l-.31-.32a1 1 0 00-1.42 1.42l2 2a1 1 0 001.42 0l2-2a1 1 0 00-1.42-1.42l-.24.25a4 4 0 017.46-1.45A3.85 3.85 0 0120 20a4 4 0 01-4 4 3.85 3.85 0 01-1.91-.49 1 1 0 00-1 1.76 6 6 0 008.14-8.14z"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
}

export default RescheduleIcon;